import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface MailPictoProps extends pictoProps {
}

export interface MailPictoState extends pictoState {
}

export class MailPicto extends Picto<MailPictoProps,MailPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.mailPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(MailPicto);
